<template>
  <custom-dialog append-to-body width="75%" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="bind-device-dialog" style="padding: 0 24px">
      <div class="search-hd clear" style="text-align: right">
        <div style="float: right">
          <search-input width="300px" v-model="formSearch.search" :placeholder="$t('b_device1_jshsbmc')" @fetch="onPageChange({ page: 1 })"></search-input>
        </div>
        <div style="float: right; margin-right: 12px">
          <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
        </div>
      </div>
      <div class="query-filter">
        <div class="params-form" v-show="isFilter">
          <el-row :gutter="23">
            <el-col :span="6">
              <div class="item">
                <div class="label">{{ $t('b_device1_cpxh') }}</div>
                <div class="value">
                  <custom-select
                    url="productCodeSelectList"
                    v-model="formSearch.productCode"
                    :props="{ label: 'productCode', value: 'productCode' }"
                    @change="onPageChange({ page: 1 })"
                    :placeholder="$t('com_please_select')"
                    width="100%"
                    theme="yellow"
                  ></custom-select>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="item">
                <div class="label">{{ $t('b_device1_zzmc') }}</div>
                <div class="value ub">
                  <custom-select
                    @clear="formSearch.orgName = ''"
                    v-model="formSearch.orgType"
                    code="bas_org_type"
                    :props="{ label: 'name', value: 'value' }"
                    @change="onPageChange({ page: 1 })"
                    :placeholder="$t('com_please_select')"
                    width="120px"
                    theme="yellow"
                  ></custom-select>
                  <el-input :disabled="!formSearch.orgType" v-model="formSearch.orgName" @input="onPageChange({ page: 1 })" clearable :placeholder="$t('com_please_input')"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="item">
                <div class="label">{{ $t('b_device1_xmmc') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.locationName" @input="onPageChange({ page: 1 })" clearable :placeholder="$t('com_please_input')"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="item">
                <div class="label">{{ $t('b_device1_he_tong_bian_hao') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.contractNo" @input="onPageChange({ page: 1 })" clearable :placeholder="$t('com_please_input')"></el-input>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <custom-table
        stripe
        height="500px"
        type="checkbox"
        tableCode="portal_select_device"
        v-model="tableSelect"
        @column="setColumn"
        :data="tableList"
        @filter="filterChange"
        @sort="sortChange"
      ></custom-table>
      <div class="table-page">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" @click="bindDevice">{{ $t('com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

// b_device1_cpxh: 产品型号// b_device1_zzmc: 组织名称// b_device1_xmmc: 项目名称// b_device1_he_tong_bian_hao: 合同编号// b_device1_jshsbmc: 机身号/设备名称

export default {
  mixins: [dialogMixins],
  data() {
    return {
      isFilter: false,
      tableList: [],
      totalRows: 0,
      tableSelect: [],
      formSearch: {
        bizId: '',
        bizType: '',
        parentId: '',
        isAss: 0,
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        orgType: '',
        orgName: '',
        locationName: '',
        contractNo: '',
      },
    };
  },
  computed: {
    rootOrgId: function () {
      const userInfo = this.$store.state.userInfo || {};
      return userInfo.rootOrgId;
    }
  },
  mounted() {
    this.mergeLanguage(null, 'portal_bind_device_dialog');
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.formSearch.bizId = this.model.user && this.model.user.bizId ? this.model.user.bizId : this.model.organ.bizId;
      this.formSearch.bizType = this.model.user && this.model.user.bizId ? this.model.user.bizType : this.model.organ.bizType;
      this.formSearch.parentId = this.model.organ.orgId || this.rootOrgId;
      this.getDeviceList();
    },
    // 获取设备列表
    getDeviceList: function () {
      this.$getJSON(apis.BizDevicePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },
    // 关联设备
    bindDevice: function () {
      const deviceIds = this.tableSelect.map(t => t.deviceId);
      this.$postJSON(
        apis.DeviceBind,
        {
          bizId: this.model.user && this.model.user.bizId ? this.model.user.bizId : this.model.organ.bizId,
          bizType: this.model.user && this.model.user.bizId ? this.model.user.bizType : this.model.organ.bizType,
          parentId: this.model.user && this.model.user.bizId ? this.model.organ.bizId : this.model.organ.parentId,
          deviceIds: deviceIds,
        },
        true
      ).then(() => {
        this.$message({
          message: this.$t('com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.bind-device-dialog {
  .icon-filter {
    display: inline-block;
    text-align: center;
    box-sizing: border-box;
    font-size: 14px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    color: $--color-text-primary;
    box-shadow: 0 0 0 1.5px #202945 inset;
    border-radius: 50px;
    cursor: pointer;
  }
}
</style>
